<div class="terms-modal">
    <div class="terms-modal-close">
        <i class="icon-edponline-Bop-078 rotate-180" data-modal="dismiss()" (click)="close()"  aria-hidden="true"></i>
    </div>
    <div class="terms-modal-container d-flex flex-column">
        <span class="terms-modal-title">
            {{"pt.edp.edponline.overlay.communications.consents" | translate}}
        </span>

        <span class="terms-modal-subtitle">
            {{"pt.edp.edponline.overlay.communications.consents.subtitle" | translate}}
        </span>

        <div class="terms-modal-consents d-flex flex-column">
            <div class="consent-info-container" *ngFor="let consent of generalConsents">
                <div class="mb-5" *ngIf="consent.Id !== 'CONS_1' && consent.Id !== 'CONS_3'">
                    <div class="d-flex flex-row justify-content-between">
                        <edp-input-toogle
                            [title]="'pt.edp.edponline.communications.consents.title.' + consent.Id"
                            [toogleValue]="consent.Value"
                            (checked)="setOption($event, consent.Id)"
                            [sufix]="'-' + consent.Id "
                        ></edp-input-toogle>

                        <i class="icon-edponline-Bop-074 d-md-none d-block" [ngClass]="{'icon-edponline-Bop-075': !!consent.expand}" aria-hidden="true" (click)="expand(consent.Id)"></i>
                    </div>

                    <div class="d-flex flex-column" >
                        <span class="legal">{{"pt.edp.edponline.communications.consents.example." + consent.Id | translate}}</span>
                        <span class="question" [ngClass]="{'expand': !!consent.expand}" [innerHTML]="'pt.edp.edponline.communications.consents.' + consent.Id | translate"></span>
                    </div>
                </div>
            </div>

            <div class="consent-info-container mb-4" >
                <edp-input-toogle
                    [title]="'pt.edp.edponline.communications.consents.select.all'"
                    [toogleValue]="selectedAll"
                    (checked)="setAll($event)"
                    [sufix]="'-all'"
                ></edp-input-toogle>
            </div>

            <button class="btn btn-primary" type="button" (click)="submit()" >
                {{"pt.edp.edponline.communications.consents.update" | translate}}
            </button>
        </div>

    </div>
</div>
